const globalSettings = {
  title: "Global settings",
  sections: {
    profile: "Profile settings",
    business: "Business settings",
    product: "Lappa settings",
  },
  cards: {
    personalDetails: {
      title: "Personal details",
      desc: "Contact information, password, authentication methods",
    },
    notificationPreferences: {
      title: "Notification Preferences",
      desc: "Product updates, service notifications and monthly newsletter",
    },
    business: {
      title: "Business",
      desc: "Business details, sensitive actions",
    },
    team: {
      title: "Team",
      desc: "Team members, roles and permissions",
    },
    sso: {
      title: "Single Sign-On (SSO)",
      desc: "Add domain, verification status, SSO status",
    },
    referral: {
      title: "Referral Program",
      desc: "Personal invite link, invite via email and invites list",
    },
    applications: {
      title: "Applications",
      desc: "L'Tax, L'EPR, L'Invoice. Manage L'Applications",
    },
    productBillingHistory: {
      title: "Billings",
      desc: "Tax invoices, proforma, credit notes and payment documents",
    },
    billings: {
      title: "Plans",
      desc: "Plans, Add-ons and consumption",
    },
    payments: {
      title: "Payments",
      desc: "Payment methods, billing contact and priority currency",
    },
    integrations: {
      title: "Integrations",
      desc: "Connect and manage ecommerce platforms, marketplaces, and accounting tools",
    },
    stores: {
      title: "Stores",
      desc: "Add, configure, and manage your stores",
    },
    sandbox: {
      title: "Sandbox",
      desc: "Trial mode, sandbox on/off and data cleanup",
    },
  },
};

export default globalSettings;
